// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__W8zCD","img":"PageNotFound_img__nuYpw"};